import React from "react";
import "../styles/Services.css";
import ServiceHeroSection from "../content/serviceData/serviceHeroSection/ServiceHeroSection";
import DigitalDevelopmentZone from "../content/serviceData/digitalDevelopmentZone/DigitalDevelopmentZone";
import CareerGrowthZone from "../content/serviceData/careerGrowthZone/CareerGrowthZone";
import TrainingInternshipZone from "../content/serviceData/traingsAndInternship/TrainingInternshipZone";
import HrBusinessSolutions from "../content/serviceData/hrBusinessSolutions/HrBusinessSolutions";
import CreativeZone from "../content/serviceData/creativeZone/CreativeZone";
import FinalCTASection from "../content/serviceData/careerGrowthZone/finalCTASection/FinalCTASection";

function Services() {
  return (
    <>
      <ServiceHeroSection />
      <DigitalDevelopmentZone />
      <CareerGrowthZone />
      <TrainingInternshipZone />
      <HrBusinessSolutions />
      <CreativeZone />
      <FinalCTASection />
    </>
  );
}

export default Services;
